import { schema } from "normalizr";
import { ShippingPromotion as ShippingPromotionRecord } from "records/shipping-promotion";

export const ShippingPromotion = new schema.Entity(
    "shippingPromotion",
    {},
    {
        idAttribute: "id",
    }
);

(ShippingPromotion as any).record = ShippingPromotionRecord;
